import { getConfig } from '../../../app/src/services/config';

const { webHost } = getConfig();

export const parseQueryString = (search) => {
  const rawParams = (search || '').replace('?', '').split('&');
  const extractedParams = {};
  rawParams.forEach((item) => {
    item = item.split('=');
    extractedParams[item[0]] = item[1];
  });
  return extractedParams;
};

export const extractProdcutsFromOffers = (data) => {
  const { items } = data || {};
  const { regular = [], promoted = [] } = items || {};
  return regular.length ? regular : promoted;
};

export const getOffersListingUrl = (params) => {
  const { category, sort, page, phrase, searchMode, offset, include } = params || {};
  const categoryId = category ? `category.id=${category}&` : '';
  const phraseFormatted = phrase ? `phrase=${phrase}&` : '';
  const sortFormatted = sort ? `sort=${sort}&` : '';
  const offsetFormatted = offset ? `limit=12&offset=${offset || (page - 1) * 12}&` : '';
  const searchM = searchMode !== undefined ? `${searchMode ? 'DESCRIPTIONS' : 'REGULAR'}` : '';
  const includeFormatted = include ? `include=${include}&` : '';
  return `offers/listing?${categoryId}${phraseFormatted}${sortFormatted}${searchM}${offsetFormatted}${includeFormatted}`;
};

export const getOffersUrl = (params) => {
  const {
    category,
    page = 1,
    sort = '',
    query = '',
    method = 'search',
    make = '',
    model = '',
    language = 'uk-UA',
    productId,
    status = '',
  } = params || {};
  const categoryId = category ? `category=${category}&` : '';
  const queryFormatted = query ? `query=${query}&` : '';
  const productParam = productId ? `product_id=${productId}&` : '';
  const modelParam = model ? `model=${model}&` : '';
  const brandParam = make ? `make=${make}&` : '';
  const pageParam = page ? `page=${page}` : '';
  const statusParam = status ? `&status=${status}` : '';
  return `${
    window.location.protocol
  }//xpart.in.ua/allegro?${pageParam}&sort=${sort}&${queryFormatted}${modelParam}${brandParam}${categoryId}${productParam}method=${method}&language=${language}${statusParam}`;
};

export const getCartTotal = (cart) =>
  (cart || []).reduce(
    (prevValue, currentValue) => parseFloat(currentValue.price) * currentValue.count + prevValue,
    0,
  );

export const formatOptions = (list = [], valueKey = '_id', key = 'name') =>
  list.map((item) => ({ label: item[key], value: item[valueKey] }));

export const loadIcon = (path = '') => {
  try {
    return require(`../icons/${path}`);
  } catch {
    return '';
  }
};
